// TabContext.tsx
import { useTimelineStore } from '@/store/timeline';
import React, { createContext, useContext, useState } from 'react';

const TimeframeTabContext = createContext<{
  activeTab: string;
  setActiveTab: (tab: string) => void;
}>({
  activeTab: '1W',
  setActiveTab: () => {},
});

export const TimeframeTabProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { timeline, set } = useTimelineStore()
  const [activeTab, setActiveTab] = useState(timeline);
  const setTimelineTab = (value: string) => {
    setActiveTab(value)
    set(value)
  }
  return (
    <TimeframeTabContext.Provider value={{ activeTab, setActiveTab: setTimelineTab }}>
      {children}
    </TimeframeTabContext.Provider>
  );
};

export const useTimeframeTabContext = () => useContext(TimeframeTabContext);
